import { Typography, Spin } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { LeftOutlined } from '@ant-design/icons';
import '../../styles/_patientCard.scss';
import {
    useGetPatientDetailsQuery,
    useDropdownOptionsQuery,
} from '../../features/patient/patientService';
import { RequestConsultationForm } from './RequestConsultationForm';
import PageTitle from '../../components/PageTitle';

const PatientRequestConsultation = () => {
    const { Title } = Typography;
    const navigate = useNavigate();
    const { id: patientId = '' } = useParams();

    const { data: patientDetails, isLoading: patientDetailsLoading } =
        useGetPatientDetailsQuery({ id: patientId });
    const { data: dropdownOptionsData, isLoading: dropdownOptionsLoading } =
        useDropdownOptionsQuery();

    const canShow = !dropdownOptionsLoading && !patientDetailsLoading;

    return (
        <div>
            <PageTitle
                title="Request Consult"
                onClick={() => navigate(`/patient/${patientId}`)}
            />
            {!canShow && <Spin spinning size="large" />}
            {canShow && patientDetails?.hospiceOrganizationId && (
                <RequestConsultationForm
                    hospiceOrganizationId={
                        patientDetails?.hospiceOrganizationId
                    }
                    consultReasons={dropdownOptionsData?.consultReasons}
                />
            )}
        </div>
    );
};

export default PatientRequestConsultation;
